<script>
export default {
  components: {},
  mixins: [],
  props: {
    i18nKey: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
  },
  validations: {},
  data() {
    return {
      variableOfControl: this.checked,
    };
  },
  computed: {
    label() {
      return this.$t(this.i18nKey);
    },
  },
  watch: {
    checked() {
      this.variableOfControl = this.checked;
    },
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<template>
  <div class="flex gap-2">
    <input
      v-model="variableOfControl"
      type="checkbox"
      name="metric-name-label-in-widget"
    />
    <label for="metric-name-label-in-widget">{{ label }}</label>
  </div>
</template>
